// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__S4B6x","title":"styles_title__1Sb6x","itemHeading":"styles_itemHeading__IRKg2"};